<template>
    <SpecialStudentLayout>
        <transition name="fade" mode="out-in">
            <LoginComponent
                ref="loginComponent"
                v-if="currentView === 'login'"
                @switch-to-register="currentView = 'register'"
                @forgot-password="currentView = 'pin-reminder'"
                key="login-view"
            />

            <RegisterComponent
                ref="registerComponent"
                v-else-if="currentView === 'register'"
                @switch-to-login="currentView = 'login'"
                key="register-view"
            />

            <PinReminderComponent
                ref="pinReminderComponent"
                v-else-if="currentView === 'pin-reminder'"
                @switch-to-login="currentView = 'login'"
                key="pin-reminder-view"
            />
        </transition>
    </SpecialStudentLayout>
</template>

<script>
import SpecialStudentLayout from "../layouts/SpecialStudentLayout.vue";
import LoginComponent from "../components/LoginComponent.vue";
import RegisterComponent from "../components/RegisterComponent.vue";
import PinReminderComponent from "../components/PinReminderComponent.vue";

export default {
    name: "Index",
    components: {
        SpecialStudentLayout,
        LoginComponent,
        RegisterComponent,
        PinReminderComponent
    },
    data() {
        return {
            currentView: 'login',
        }
    },

    async created() {
        await this.$store.getters['SpecialStudentApplicationRegister/checkIsLogin']
    },
}
</script>

